export const FORM_EDIT_EMPLEADO = {
  // Datos generales
  numeroEmpleado: "",

  // Datos personales
  nombre: "",
  apellidoPaterno: "",
  apellidoMaterno: "",
  curp: "",
  rfc: "",
  fechaNacimiento: "",
  numeroSeguroSocial: "",
  gradoEstudios: "",

  // Contacto de emergencia (solo uno, plano)
  contactoEmergenciaNombre: "",
  contactoEmergenciaParentesco: "",
  contactoEmergenciaTelefono: "",
  contactoEmergenciaTelefonoAlterno: "",
  contactoEmergenciaDireccion: "",

  // Datos bancarios (plano)
  clabeNomina: "",
  bancoNomina: "",
  titularNomina: "",

  clabeAdicional: "",
  bancoAdicional: "",
  titularAdicional: "",

  // Datos de puesto (plano)
  puesto: "",
  area: "",

  // Periodo actual (solo uno, plano)
  fechaIngreso: "",
  fechaEgreso: "",
  activo: true,

  // Vacaciones actuales (ejemplo de uno, plano)
  vacacionFolio: "",
  vacacionDias: "",
  vacacionFechas: "", // Ejemplo: "2024-07-01,2024-07-02,2024-07-03"
  vacacionAnio: "",

  // Permiso actual (plano, ejemplo de uno)
  permisoMotivo: "",
  permisoFecha: "",
  permisoFolio: "",

  // Incapacidad actual (plano, ejemplo de uno)
  incapacidadMotivo: "",
  incapacidadFechaInicio: "",
  incapacidadFechaFin: "",
  incapacidadFolioIMSS: "",

  // Falta actual (plano, ejemplo de uno)
  faltaFecha: "",
  faltaMotivo: "",
  faltaJustificada: false
};
